export const ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_PAGE_SIZE = 25;
export const ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_MAX_MARK_READ = 50;

function clampPageSize(pageSize) {
  const size = Number(pageSize);
  return Number.isFinite(size) && size > 0
    ? Math.floor(size)
    : ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_PAGE_SIZE;
}

function optionalToken(pageToken) {
  if (pageToken == null || pageToken === '') return null;
  return String(pageToken);
}

/**
 * Strict allowlisted list request. Default pageSize 25.
 * @param {{
 *   pageSize?: number,
 *   pageToken?: string | null,
 *   unreadOnly?: boolean,
 * }} [params]
 */
export function buildListAdminProspectResponseNotificationsRequest({
  pageSize = ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_PAGE_SIZE,
  pageToken,
  unreadOnly,
} = {}) {
  const request = {
    pageSize: clampPageSize(pageSize),
  };
  const token = optionalToken(pageToken);
  if (token) request.pageToken = token;
  if (unreadOnly === true) request.unreadOnly = true;
  return request;
}

/**
 * Unread-count request — empty body only (no keys).
 */
export function buildGetAdminProspectResponseNotificationUnreadCountRequest() {
  return {};
}

/**
 * Strict allowlisted mark-read request.
 * @param {{ notificationIds: string[] }} params
 */
export function buildMarkAdminProspectResponseNotificationsReadRequest({
  notificationIds,
} = {}) {
  const ids = [];
  const seen = new Set();
  const raw = Array.isArray(notificationIds) ? notificationIds : [];
  for (const entry of raw) {
    if (typeof entry !== 'string') continue;
    const id = entry.trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
    if (ids.length >= ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_MAX_MARK_READ) break;
  }
  return { notificationIds: ids };
}

/**
 * Optional recover request (admin repair). Default dryRun true.
 * Opaque pageToken continues from a prior recover page; omitted when absent/empty.
 * @param {{
 *   pageSize?: number,
 *   dryRun?: boolean,
 *   pageToken?: string | null,
 * }} [params]
 */
export function buildRecoverAdminProspectResponseNotificationsRequest({
  pageSize = ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_PAGE_SIZE,
  dryRun = true,
  pageToken,
} = {}) {
  const request = {
    pageSize: clampPageSize(pageSize),
    dryRun: dryRun !== false,
  };
  const token = optionalToken(pageToken);
  if (token) request.pageToken = token;
  return request;
}
